module.exports = __webpack_public_path__ + "img/banner-selvycheckup-download.52cec6cd.png";